import { DashBoardPage } from './DashBoardPage';
import { PendingHandpayWins } from './PendingHandpayWins';
import { Wins } from './Wins';
import { Win } from './Win';
import { Snapshot } from './Snapshot';
import { GameConfigurationPage } from './GameConfigurationPage';
import { ConfigurationPage } from './ConfigurationPage';
import { ConfigurationDetailPage } from './ConfigurationDetailPage';
import { AssignedCustomerOperationsPage } from './AssignedCustomerOperationsPage';
import { AvailableCustomerOperationsPage } from './AvailableCustomerOperationsPage';
import { IndexPage } from './IndexPage';

export {
    DashBoardPage,
    PendingHandpayWins,
    Wins,
    Win,
    GameConfigurationPage,
    ConfigurationPage,
    ConfigurationDetailPage,
    Snapshot,
    AssignedCustomerOperationsPage,
    AvailableCustomerOperationsPage,

    IndexPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/index.ts
 **/